window.addEventListener('load', () => {
  const linkDropdowns = document.querySelectorAll('[data-link_dropdown]');
  if (!linkDropdowns.length) return;
  linkDropdowns.forEach((dropdown) => {
    const trigger = dropdown.querySelector('[data-dropdown_trigger]');
    const content = dropdown.querySelector('[data-dropdown_content]');
    if (!trigger || !content) return;
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      if (dropdown.dataset.hasOwnProperty('open')) {
        dropdown.removeAttribute('data-open');
      } else {
        const current = document.querySelector('[data-link_dropdown][data-open]');
        if (current) current.removeAttribute('data-open');
        dropdown.dataset.open = '';
      }
      content.classList.toggle('flex');
      content.classList.toggle('hidden');
    });
  });
});
